import { ProductState } from 'data/__generated__';

export const PRODUCTS_STATES_LABELS = {
    Created: 'Créé',
    Regular: 'Actif',
    Archived: 'Archivé',
};

export const UNAVAILABLE_PRODUCT_STATES = [ProductState.Created, ProductState.Archived];
